<template>
  <div class="modal-card">
    <div class="row-width-actions-bar is-border-bottom">
      <div class="columns is-gapless is-vcentered">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">{{ params.title }}</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click.prevent.stop="close()"
            aria-label="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>

    <div
      class="has-background-warning columns is-gapless is-marginless is-vcentered"
      v-if="params.warningType === 'adf'">
      <div class="column is-paddingless-left is-padding-top-small is-padding-bottom-small has-text-centered">
        <div class="is-size-7 is-uppercase has-text-weight-medium">
          Ces fichiers sont automatiquement liés au document "appel de fond" généré dans l'adv du programme
        </div>
      </div>
    </div>
    <section class="modal-card-body">
      <view-file-list
        :documents="documents"
        :is-array="true"
        :can-drag="false"
        :can-edit="true"
        :edit-display-enabled="false"
        @delete="deleteDocument"></view-file-list>
    </section>
    <footer class="modal-card-foot">
      <div class="column is-1"></div>
      <button
        @click.prevent.stop="close"
        class="button is-medium is-light is-uppercase is-fullwidth">
        Annuler
      </button>
      <button
        @click="submit"
        class="button is-medium is-success is-uppercase is-fullwidth has-text-white"
        form="formDocumentModalEdit">
        Valider
      </button>
      <div class="column is-1"></div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'DocumentModalList',
  components: {
    ViewFileList: () => import('@/components/adv/ViewFileList')
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    source: {
      type: Array,
      required: true
    },
    params: {
      type: Object
    }
  },
  computed: {
    documents () {
      return this.source
    }
  },
  methods: {
    deleteDocument (idx) {
      this.documents.splice(idx, 1)
    },
    submit () {
      this.$emit('submit', this.documents)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
